export default __webpack_public_path__ + "static/media/jaotee_img2.21baa5cc.webp";